import React, { useEffect, useState } from "react";
import { useForm, FormProvider, useWatch } from "react-hook-form";
import parse from "html-react-parser";
import { common } from "../../utils";
import { API_URL } from "../../utils/api-utils";
import { inform_success } from "../../utils/alert";
import { checkDateRange } from "../../utils/date";
import axios from "axios";
//Material
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
//Component
import { BaseContainer } from "../../stories/base-container";
import { BoxTemplate1 } from "../../stories/Box";
import FormInput from "../../stories/hook-controls/input";
import { MaterialUIDateTimePickers } from "./../../stories/hook-controls/datepicker/datetimepicker";
// import Editor from 'ckeditor5-custom-build/build/ckeditor';
// import { CKEditor } from '@ckeditor/ckeditor5-react'
import FormCheckBox from "../../stories/hook-controls/checkbox";
import "tinymce";

// Default Icons
import "tinymce/icons/default";

// Theme
import "tinymce/themes/silver";

// Plugins
import "tinymce/plugins/image";
import "tinymce/plugins/advlist";
import "tinymce/plugins/autolink";
import "tinymce/plugins/link";
import "tinymce/plugins/lists";
import "tinymce/plugins/charmap";
import "tinymce/plugins/hr";
import "tinymce/plugins/anchor";
import "tinymce/plugins/spellchecker";
import "tinymce/plugins/searchreplace";
import "tinymce/plugins/wordcount";
import "tinymce/plugins/code";
import "tinymce/plugins/fullscreen";
import "tinymce/plugins/insertdatetime";
import "tinymce/plugins/media";
import "tinymce/plugins/nonbreaking";
import "tinymce/plugins/table";
import "tinymce/plugins/template";
import "tinymce/plugins/help";
import "tinymce/plugins/print";
import "tinymce/plugins/preview";
import "tinymce/plugins/visualblocks";
import "tinymce/plugins/paste";
// CSS
import "tinymce/skins/ui/oxide/skin.min.css";

import { Editor } from "@tinymce/tinymce-react";
function BannerMaster() {
  const method = useForm({ mode: "all" });
  const { control, setValue, setError, getValues } = method;
  const [textPreview, setTextPreview] = useState("");
  const [textInit, setTextInit] = useState("");
  const rich = useWatch({
    control,
    name: "CONTENT", // without supply name will watch the entire form, or ['firstName', 'lastName'] to watch both
    defaultValue: "", // default value before the render
  });
  useEffect(() => {
    (async () => {
      let res = await GetAnnouncement();
      let data = common.setDataToFormHookV2(res);
      data?.forEach(({ name, value }) => setValue(name, value));
      setTextInit(res["CONTENT"]);
      setTextPreview(res["CONTENT"]);
    })();
  }, [setValue]);

  function validate(params) {
    let result = true;
    if (!checkDateRange(getValues().DATE_FROM, getValues().DATE_TO)) {
      setError("DATE_FROM", {
        type: "manual",
        message: `Invalid date range`,
      });
      setError("DATE_TO", {
        type: "manual",
        message: `Invalid date range`,
      });
      result = false;
    }

    return result;
  }
  async function Save() {
    if (!validate()) return;
    let paramForm = method.getValues();

    let param = {
      DATE_FROM: paramForm["DATE_FROM"],
      DATE_TO: paramForm["DATE_TO"],
      CONTENT: textPreview,
      ACTIVE: paramForm["ACTIVE"],
    };
    console.log(param);
    let error = await UpdateAnnouncement(param);
    if (!error) inform_success();
  }

  const handleEditorChange = (content, editor) => {
    const data = content.target.getContent();
    setTextPreview(data);
    console.log("Content was updated:", data);
  };
  return (
    <BaseContainer maxWidth={false}>
      <FormProvider {...method}>
        <BoxTemplate1 height="80vh" title="Announcement">
          <Box display="flex" pb={3}>
            <Box mr={1}>
              <MaterialUIDateTimePickers name="DATE_FROM" label="From" />
            </Box>
            <Box>
              <MaterialUIDateTimePickers name="DATE_TO" label="To" />
            </Box>
            <Box
              mt={3}
              ml={4.5}
              maxWidth="500px"
              flexGrow={1}
              style={{ marginTop: "0" }}
            >
              <FormCheckBox key="ACTIVE" name="ACTIVE" label="Active" />
            </Box>
          </Box>

          <Box minWidth="600px" minHeight="600px">
            <Editor
              //apiKey='i28s76b7n9n8xrhqhlo8anftu1z8t7v2uec4r2n098jpke3u'
              initialValue={textInit}
              init={{
                height: 600,
                menubar: true,
                plugins: [
                  "advlist autolink lists link image",
                  "charmap print preview anchor help",
                  "searchreplace visualblocks code",
                  "insertdatetime media table paste wordcount",
                ],
                toolbar:
                  "undo redo | formatselect | bold italic | alignleft aligncenter alignright | bullist numlist outdent indent | image",
              }}
              onChange={handleEditorChange}
            />
          </Box>
          <Button variant="contained" onClick={Save}>
            Save
          </Button>
        </BoxTemplate1>
        <br />
        {/* <BoxTemplate1 title="Preview">
          {common.isEmptyStr(textPreview) ? null : parse(textPreview)}
        </BoxTemplate1> */}
      </FormProvider>
    </BaseContainer>
  );
}
//api
const GetAnnouncement = async (param) => {
  let url = `${API_URL.Loader}/api/master/GetAnnouncement`;
  let { result } = await common.to(axios.post(url));
  if (result && result.data) return result.data;
};
const UpdateAnnouncement = async (param) => {
  let url = `${API_URL.Loader}/api/master/UpdateAnnouncement`;
  let { result, error } = await common.to(axios.post(url, param));
  return error;
};

export default BannerMaster;
